<template>
  <h2 v-if="this.bold" :class="displayCss">
    {{ valueInput }}
  </h2>
  <div v-else :class="displayCss">
    {{ valueInput }}
  </div>
</template>

<script>
import FormatNumberService from "../services/format-number-service";

export default {
  name: "numeric-label",
  props: {
    value: String,
    displayType: String,
    class: String,
    bold: Boolean,
    formControl: Boolean
  },
  data () {
    return {
      negativeNumber: false,
      highlightTextbox: false,
      displayCss: "",
      valueInput: ""
    }
  },
  mounted() {
    this.updateValues();
  },
  watch: {
    value: function() {
      this.updateValues();
      this.setInputClassCss();
    },
    negativeNumber: function() {
      this.setInputClassCss();
    },
    displayType: function() {
      this.updateValues();
    },
    valueInput: function() {
      this.setInputClassCss();
    }
  },
  methods: {
    updateValues() {
      this.valueInput = this.formatValue(this.value);
      this.updateNegativeNumber(this.value);
    },
    updateNegativeNumber() {
      this.negativeNumber = this.allowNegativeNumber ? false : this.displayType === "currency" || this.displayType === "currencyDecimal" ? Number(this.value) < 0 : false;
    },
    setInputClassCss() {
      this.displayCss = "text-end m-0" + " " + this.class;
      if (((!this.negativeNumber && Number(this.value) < 0) || this.negativeNumber) && !this.class.includes("faded-text")) {
        if (this.class.includes("more-faded-red-text")) {
          this.displayCss = this.displayCss + " " + "text-faded-red-35";
        } else if (this.class.includes("faded-red-text")) {
          this.displayCss = this.displayCss + " " + "text-faded-red-75";
        } else {
          this.displayCss = this.displayCss + " " + "text-red";
        }
      }
      else if (!this.class.includes("faded-text") && !this.class.includes("faded-red-text")) {
        this.displayCss = this.displayCss + " " + "text-black";
      }
      if (this.formControl) {
        this.displayCss = this.displayCss + " " + "form-control-sm";
      }
    },
    formatValue(amount) {
      switch(this.displayType) {
        case "percentage":
          return this.formatAsPercentage(amount);
        case "percentageDecimal":
          return this.formatAsPercentageDecimal(amount, this.decimal);
        case "currency":
          return this.edit ? Number(amount) : this.getFormatNumber(amount);
        case "currencyDecimal":
          return this.edit ? Number(amount).toFixed(2) : this.getFormatNumberWithDecimal(amount, this.decimal);
        case "none-format-currency":
          return Number(amount).toFixed(2);
        case "none-format-percentage":
          return Number(amount);
        //just integer number - none format
        case "none":
          return Number(amount).toFixed();
        //just decimal number - none format
        case "decimalNonFormat":
          return Number(amount).toFixed(this.decimal);
        case "string":
          return String(amount);
      }
      return amount;
    },
    formatAsPercentage(amount) {
      return FormatNumberService.formatNumberPercentage(Number(amount));
    },
    formatAsPercentageDecimal(amount, decimal) {
      return FormatNumberService.formatNumberPercentageWithDecimal(Number(amount), decimal);
    },
    getFormatNumber(amount) {
      const result = FormatNumberService.formatNumberResult(amount);
      return result;
    },
    getFormatNumberWithDecimal(amount, decimal) {
      const result = FormatNumberService.formatNumberResultWithDecimal(amount, decimal);
      return result;
    }
  }
}
</script>
